export const globalOptions = {
    parameters: {
        create: {
            title: window.i18n.__('Création'),
        },
        update: {
            title: window.i18n.__('Mise à jour'),
            options: {
                update_empty_fields: {
                    title: window.i18n.__('Si une cellule de mon fichier est vide'),
                    values: [
                        {
                            value: 'N',
                            label: window.i18n.__('Ignorer et ne rien faire'),
                            description: window.i18n.__(
                                'La cellule du fichier est ignorée et n’est pas importée dans Sellsy.',
                            ),
                        },
                        {
                            value: 'Y',
                            label: window.i18n.__('Remplacer par une valeur vide'),
                            description: window.i18n.__(
                                'La cellule du fichier est prise en compte et une valeur vide remplace celle existante dans Sellsy.',
                            ),
                        },
                    ],
                },
                overwrite_tags: {
                    title: window.i18n.__('Smart-tags de mon fichier'),
                    values: [
                        {
                            value: 'N',
                            label: window.i18n.__(
                                'Ajouter les smart-tags de mon fichier à ceux existants',
                            ),
                            description: window.i18n.__(
                                'Les smart-tags du fichier sont ajoutés à ceux déjà présents dans Sellsy.',
                            ),
                        },
                        {
                            value: 'Y',
                            label: window.i18n.__(
                                'Remplacer les smart-tags existants par ceux de mon fichier',
                            ),
                            description: window.i18n.__(
                                'Les smart-tags du fichier remplacent ceux déjà présents dans Sellsy.',
                            ),
                        },
                    ],
                },
            },
        },
    },
    customFields: {
        dismiss_required_custom_fields: {
            title: window.i18n.__('Si un champ personnalisé obligatoire de mon fichier est vide'),
            values: [
                {
                    value: 'Y',
                    label: window.i18n.__(
                        'Ajouter la ligne sans la valeur du champ personnalisé obligatoire',
                    ),
                    description: window.i18n.__(
                        'La ligne du fichier est importée dans Sellsy sans la valeur du champ personnalisé obligatoire.',
                    ),
                },
                {
                    value: 'N',
                    label: window.i18n.__('Ignorer et ne pas ajouter la ligne'),
                    description: window.i18n.__(
                        'La ligne du fichier est ignorée et n’est pas importée dans Sellsy.',
                    ),
                },
            ],
        },
        use_default_values_for_empty_custom_fields: {
            title: window.i18n.__('Si une cellule de champ personnalisé de mon fichier est vide'),
            values: [
                {
                    value: 'N',
                    label: window.i18n.__('Remplacer par une valeur vide'),
                    description: window.i18n.__(
                        'Une valeur vide remplace celle existante dans Sellsy.',
                    ),
                },
                {
                    value: 'Y',
                    label: window.i18n.__('Utiliser la valeur par défaut du champ personnalisé'),
                    description: window.i18n.__(
                        'La valeur par défaut renseignée dans Sellsy est utilisée. Si vous n’avez défini aucune valeur par défaut pour le champ personnalisé, alors la valeur sera laissée vide.',
                    ),
                },
            ],
        },
        insert_new_custom_fields_enum_values: {
            title: window.i18n.__(
                "Si une option de liste de mon fichier n'existe pas dans Sellsy ",
            ),
            values: [
                {
                    value: 'Y',
                    label: window.i18n.__('Ajouter les options à celles existantes'),
                    description: window.i18n.__(
                        'Les options (valeurs) du fichier sont ajoutées à celles déjà existantes dans les paramètres du champ personnalisé dans Sellsy.',
                    ),
                },
                {
                    value: 'N',
                    label: window.i18n.__('Utiliser uniquement les options existantes'),
                    description: window.i18n.__(
                        'Seuls les options (valeurs) déjà existantes dans Sellsy et gérées dans les paramètres du champ personnalisé sont acceptées.',
                    ),
                },
            ],
        },
    },
};

export const defaultOptions = {
    insert_new_records: 'Y',
    update_existing_records: 'Y',
    update_empty_fields: 'N',
    overwrite_tags: 'N',
    dismiss_required_custom_fields: 'Y',
    insert_new_custom_fields_enum_values: 'Y',
    use_default_values_for_empty_custom_fields: 'N',
    columns: [],
};
